export const normalizeStepFrequencyRows = (rows) => (rows || []).map((item) => {
    const totalFrequency = Number(item.totalFrequency) || 0;
    const failCount = Number(item.failCount) || 0;

    return {
        stepNumber: item.stepNumber,
        totalFrequency,
        failCount,
        failPercentage: totalFrequency > 0 ? (failCount / totalFrequency) * 100 : 0,
        avgMeasureValue:
            item.avgMeasureValue !== null && item.avgMeasureValue !== undefined
                ? Number(item.avgMeasureValue)
                : null,
    };
});

export const filterStepRows = (rows, onlyWithValues) => {
    const filteredRows = onlyWithValues
        ? rows.filter((item) => Number(item.failCount) > 0 || item.avgMeasureValue !== null)
        : rows;

    return [...filteredRows].sort((a, b) => b.failCount - a.failCount);
};

export const buildStepChartData = (rows) => {
    const sortedRows = [...rows].sort((a, b) => b.failPercentage - a.failPercentage);

    return {
        labels: sortedRows.map((item) => `Step ${item.stepNumber}`),
        datasets: [
            {
                label: 'Fail percentage',
                data: sortedRows.map((item) => Number(item.failPercentage.toFixed(2))),
                backgroundColor: 'rgba(214, 69, 69, 0.72)',
                borderColor: '#d64545',
                borderWidth: 1,
            },
        ],
    };
};

export const stepChartOptions = (title = 'Fail Percentage by Step Number') => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { position: 'bottom' },
        title: {
            display: true,
            text: title,
        },
        tooltip: {
            callbacks: {
                label: (context) => `${context.dataset.label}: ${context.raw}%`,
            },
        },
    },
    scales: {
        y: {
            beginAtZero: true,
            title: { display: true, text: 'Fail percentage (%)' },
        },
        x: {
            title: { display: true, text: 'Step number' },
        },
    },
});

export const getStepMetrics = (rows) => {
    const totalExecutions = rows.reduce((sum, row) => sum + row.totalFrequency, 0);
    const totalFails = rows.reduce((sum, row) => sum + row.failCount, 0);
    const worstStep = rows.length ? [...rows].sort((a, b) => b.failPercentage - a.failPercentage)[0] : null;
    const failureRate = totalExecutions ? ((totalFails / totalExecutions) * 100).toFixed(2) : '0.00';

    return [
        { label: 'Steps shown', value: rows.length, tone: 'neutral' },
        { label: 'Executions', value: totalExecutions, tone: 'neutral' },
        { label: 'Failures', value: totalFails, tone: 'fail' },
        { label: 'Overall fail rate', value: `${failureRate}%`, tone: 'fail' },
        { label: 'Highest fail step', value: worstStep ? `Step ${worstStep.stepNumber}` : '-', tone: 'neutral' },
    ];
};

export const getQuickRange = (range) => {
    const today = new Date();
    const start = new Date(today);

    if (range === 'today') return { start: today, end: today };
    if (range === 'last7') {
        start.setDate(today.getDate() - 7);
        return { start, end: today };
    }
    if (range === 'month') return { start: new Date(today.getFullYear(), today.getMonth(), 1), end: today };

    start.setDate(today.getDate() - 30);
    return { start, end: today };
};
